import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./DetailPages.css";
import Title from "../../assets/zlataRybka/title.webp";
import Picture1 from "../../assets/zlataRybka/1.webp";
import Picture2 from "../../assets/zlataRybka/2.webp";
import Picture3 from "../../assets/zlataRybka/3.webp";
import Picture4 from "../../assets/zlataRybka/4.webp";
import Picture5 from "../../assets/zlataRybka/5.webp";
import Picture6 from "../../assets/zlataRybka/6.webp";
import Picture7 from "../../assets/zlataRybka/7.webp";
import Picture8 from "../../assets/zlataRybka/8.webp";
import Picture9 from "../../assets/zlataRybka/9.webp";
import Picture10 from "../../assets/zlataRybka/10.webp";
import Picture11 from "../../assets/zlataRybka/11.webp";
import Picture12 from "../../assets/zlataRybka/12.webp";
import Picture13 from "../../assets/zlataRybka/13.webp";
import Picture14 from "../../assets/zlataRybka/14.webp";
import Picture15 from "../../assets/zlataRybka/15.webp";
import Picture16 from "../../assets/zlataRybka/16.webp";
import Picture17 from "../../assets/zlataRybka/17.webp";
import Picture18 from "../../assets/zlataRybka/18.webp";
import Navbar from "../../components/NavBar/Navbar";
import ScrollButton from "../../components/ScrollTopButton/ScrollButton";
import ImageGalery from "../../components/ImageGalery/ImageGalery";
import Footer from "../../components/Footer/Footer";

const DetailPage = () => {
  const images = [
    { original: Picture1, thumbnail: Picture1 },
    { original: Picture2, thumbnail: Picture2 },
    { original: Picture3, thumbnail: Picture3 },
    { original: Picture4, thumbnail: Picture4 },
    { original: Picture5, thumbnail: Picture5 },
    { original: Picture6, thumbnail: Picture6 },
    { original: Picture7, thumbnail: Picture7 },
    { original: Picture8, thumbnail: Picture8 },
    { original: Picture9, thumbnail: Picture9 },
    { original: Picture10, thumbnail: Picture10 },
    { original: Picture11, thumbnail: Picture11 },
    { original: Picture12, thumbnail: Picture12 },
    { original: Picture13, thumbnail: Picture13 },
    { original: Picture14, thumbnail: Picture14 },
    { original: Picture15, thumbnail: Picture15 },
    { original: Picture16, thumbnail: Picture16 },
    { original: Picture17, thumbnail: Picture17 },
    { original: Picture18, thumbnail: Picture18 },
  ];

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <div className="detail-page">
        <div className="header">
          <img
            src={Title}
            alt="Header"
            className="header-image"
            loading="lazy"
          />
          <h1 className="header-title">Zlatá rybka</h1>
        </div>
        <div id="info" className="info-section">
          <p>
            Činoherní pohádka dvou herců o splněných přáních, co neudělají
            člověka šťastným. Veselá pohádka od moře o zlaté rybce, která ví, že
            bez svobody není život až zase tak veliká zábava a pro její uchování
            bude klidně plnit i naprosto nerozumná přání. A k tomu zatočí s
            mamonem a otevře člověku srdce.
          </p>
          <div className="short-info">
            <div className="info-item">
              <strong>Hrají:</strong> Adam Horký, Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Scénář:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Režie:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Hudba:</strong> Šimon Martínek
            </div>
            <div className="info-item">
              <strong>Scénografie a kostýmy:</strong> Adéla Pellarová
            </div>
            <div className="info-item">
              <strong>Výtvarná realizace kulisy:</strong> Anežka Plháková,
              Amálie Popelářová, Petr Mlejnek
            </div>
            <div className="info-item">
              <strong>Výroba kulis a kostýmů:</strong> Petr Kubík, Adéla
              Pellarová, Alžběta Zelenková, Magdaléna Popelářová, Míňa
              Podhájecká, Mirka Voříšková, Amálie Popelářová, Petr Mlejnek
            </div>
            <div className="info-item">
              <strong>Prostorová náročnost:</strong> Toto představení hrajeme ve
              třídě i na jevišti.
            </div>
            <div className="info-item">
              <strong>Produkce:</strong> Adělá Pellarová, Amálie Popelářová
            </div>
            <div className="info-item">
              <strong>Délka trvání:</strong> 45 minut
            </div>
          </div>
        </div>
        <ImageGalery images={images} h2={"foto: Petra Šplíchalová"} />
      </div>
      <ScrollButton />
      <Footer />
    </>
  );
};

export default DetailPage;
